export enum XandrMacro {
    Aaid = "aaid",
    Idfa = "idfa",
    WinId = "winId",
    AppId = "appId",
    LineItemId = "lineItemId"
}
